import { Box, ButtonProps } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { TopBarLink } from 'components/bars/TopBarActions';
import { CommentAltIcon } from 'components/icons';
import React from 'react';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { generatePath } from 'react-router-dom';
import { INNER_CHAT_LOOKUP_FROM_NODE_PATH } from 'utils/routes';

interface ChatConversationNode {
  id: string;
  __typename: string;
}

interface ChatButtonProps extends ButtonProps {
  node: ChatConversationNode;
  iconSize?: SizeProp;
  children?: React.ReactNode;
}

export const ChatButton = ({
  node,
  children,
  ...otherProps
}: ChatButtonProps) => {
  const showChatButton = ['Event', 'Space'].includes(node.__typename);

  if (!showChatButton) {
    return <></>;
  }

  return (
    <TopBarLink
      ariaLabel={t`Open conversation`}
      toChat={generatePath(INNER_CHAT_LOOKUP_FROM_NODE_PATH, {
        lookupId: node.id,
      })}
    >
      <CommentAltIcon size={otherProps.iconSize || '1x'} />
      {!!children && <Box pl={1}>{children}</Box>}
    </TopBarLink>
  );
};
